import { useEffect } from 'react';

import { useQueryParam } from '@atlassian/react-resource-router';

export const useUrlManager = (paramName: string, paramValue: string, isOpen: boolean) => {
	const [_, setQueryParam] = useQueryParam(paramName);

	useEffect(() => {
		if (isOpen) {
			setQueryParam(paramValue);
		} else {
			setQueryParam(undefined);
		}
		// Cleanup function to remove the query parameter when component unmounts
		return () => {
			setQueryParam(undefined);
		};
	}, [setQueryParam, paramValue, isOpen]);
};
